import { connect } from 'react-redux';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';

const mapStateToProps = (state, ownProps) => {
  const streamId = getShopItemsStreamId(ownProps.itemType);
  return {
    streamId,
    items: getDeviationsByIds(state, streamSelectors.getItems(state, streamId)),
    hasMore: streamSelectors.hasMore(state, streamId),
    isFetching: streamSelectors.isFetching(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchMore: () =>
      dispatch(
        withOffset.actions.fetch(getShopItemsStreamId(ownProps.itemType))
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
